module.exports = __webpack_public_path__ + "img/failed_payment_example.236adeff.png";